import Actions from 'actions';

const initialState = Object.freeze({});

function list(state = initialState, action) {
  switch (action.type) {
    case Actions.FETCH_COUNTRY_OPTIONS_REQUEST:
      return initialState;
    case Actions.FETCH_COUNTRY_OPTIONS_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.FETCH_COUNTRY_OPTIONS_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default list;
